var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();return _vm.resetPassword()}}},[_c('span',{staticClass:"icon icon-mail"},[_vm._v(" Send New Account Email")])])}
var staticRenderFns = []

export { render, staticRenderFns }